class InsertHtmlModal {
    static MODAL_SELECTOR = '.insert-html-modal__modal'
    static MODAL_OPEN_CLASS = 'insert-html-modal__modal--open'

    constructor() {
        this.emtyModalButton = document.querySelectorAll('.insert-html-modal__open-button')
        this.initClickOpenButton()
    }

    initClickOpenButton() {
        this.emtyModalButton.forEach((button) => {
            button.addEventListener('click', () => {
                if (button.classList.contains('insert-html-modal__open-button--backend')) {
                    return
                }
                let parent = button.parentElement
                let template = parent.querySelector('.insert-html-modal__modal-template')
                this.addModal(template)
                this.initClickCloseButton()
                this.initClickBackground()
            })
        })
    }

    addModal(template) {
        document.body.classList.add('stop-scrolling')
        let clone = template.content.cloneNode(true)
        document.body.appendChild(clone)
        let modal = document.querySelector(InsertHtmlModal.MODAL_SELECTOR)
        setTimeout(() => {
            modal.classList.add(InsertHtmlModal.MODAL_OPEN_CLASS)
        }, 100)
    }

    initClickCloseButton() {
        let modalCloseButton = document.querySelector('.insert-html-modal__close-button')
        modalCloseButton.addEventListener('click', () => {
            this.removeModal()
        })
    }

    initClickBackground() {
        let modalBackground = document.querySelector('.insert-html-modal__background')
        modalBackground.addEventListener('click', (event) => {
            if (event.target == modalBackground) {
                this.removeModal()
            }
        })
    }

    removeModal() {
        document.body.classList.remove('stop-scrolling')
        let modal = document.querySelector(InsertHtmlModal.MODAL_SELECTOR)
        modal.classList.remove(InsertHtmlModal.MODAL_OPEN_CLASS)
        setTimeout(() => {
            modal.remove()
        }, 200)
    }
}

if (document.readyState !== 'loading') {
    new InsertHtmlModal()
} else {
    document.addEventListener('DOMContentLoaded', new InsertHtmlModal())
}
